const prefix = "REACT_APP_";
const env = process.env.REACT_APP_ENV || "LOCAL";
const suffix = "_" + env;


export function getEnvURL_BE(): string {
  const url = process.env[prefix + "BE_URL" + suffix] || "";
  return url;
}

export function getEnvURL_FE(): string {
  const url = process.env[prefix + "FE_URL" + suffix] || "";
  return url;
}

export function getCurrentEnv(): string {
  return env;
}
